import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

const setupHeader = (el) => {
  const image = el.querySelector('[data-media]')
  const sibling = el.nextElementSibling

  ScrollTrigger.matchMedia({
    '(max-width: 767px)': function () {
      gsap.to(image, {
        scrollTrigger: {
          trigger: el,
          start: 'top top',
          endTrigger: image,
          end: 'bottom top',
          scrub: true,
        },
        y: -30,
      })

      if (sibling.nodeName === 'NAV') {
        gsap.to(sibling, {
          scrollTrigger: {
            trigger: el,
            start: 'top top',
            endTrigger: image,
            end: 'bottom top',
            scrub: true,
          },
          y: -30,
        })
      }
    },

    '(min-width: 768px)': function () {
      gsap.to(image, {
        scrollTrigger: {
          trigger: el,
          start: 'top top',
          endTrigger: image,
          end: 'bottom top',
          scrub: true,
        },
        y: -100,
      })

      if (sibling.nodeName === 'NAV') {
        gsap.to(sibling, {
          scrollTrigger: {
            trigger: el,
            start: 'top top',
            endTrigger: image,
            end: 'bottom top',
            scrub: true,
          },
          y: -130,
        })
      }
    },
  })
}

export default setupHeader
